import React from "react";
import "./OutsourceCommon.css";
import OutsourceHero from "./outsourceHero/OutsourceHero";
import OutsourceAutomation from "./outsourceAutomation/OutsourceAutomation";
import OutsourceDeliver from "./outsourceDeliver/OutsourceDeliver";
import OutsourceValues from "./outsourceValues/OutsourceValues";
import OutsourceService from "./outsourceService/OutsourceService";
import OutsourceTestimonial from "./outsourceTestimonial/OutsourceTestimonial";
import OutsourceFaster from "./outsourceFaster/OutsourceFaster";
import OutsourceOffer from "./outsourceOffer/OutsourceOffer";
import OutsourcePartner from "./outsourcePartner/OutsourcePartner";

export default function Outsource() {
  return (
    <div>
      <OutsourceHero />
      <OutsourceAutomation />
      <OutsourceDeliver />
      <OutsourceValues />
      <OutsourceOffer />
      <OutsourcePartner />
      <OutsourceFaster />
      <OutsourceTestimonial />
      <OutsourceService />
    </div>
  );
}
